import React, { useEffect, useState } from "react"
import { supabase } from "../../lib/supabaseClient"
import LocationFilters from "../Search/LocationFilters"

export default function ProductFilters({
  category,
  setCategory,
  sort,
  setSort,
  q,
  setQ,
  location,
  setLocation,
}) {
  const [categories, setCategories] = useState([])

  useEffect(() => {
    let mounted = true
    ;(async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("id, name")
        .eq("enabled", true)
        .order("name", { ascending: true })

      if (!mounted) return
      if (error) {
        console.error("Error cargando categorías:", error.message)
        setCategories([])
      } else {
        setCategories(data || [])
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className="bg-white border rounded-xl p-4 shadow-sm flex flex-col gap-4">
      <div className="flex flex-col md:flex-row gap-3 items-center">
        <input
          className="border rounded p-2 w-full md:flex-1"
          placeholder="Buscar por nombre o descripción…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <select
          className="border rounded p-2"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">Todas las categorías</option>
          {categories.map((c) => (
            <option key={c.id} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>
        <select
          className="border rounded p-2"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
        >
          <option value="price_asc">Precio: menor a mayor</option>
          <option value="price_desc">Precio: mayor a menor</option>
          <option value="distance">Distancia</option>
        </select>
      </div>
      <LocationFilters location={location} setLocation={setLocation} />
    </div>
  )
}
